<template>
    <svg id="icon-add-to-basket" xmlns="http://www.w3.org/2000/svg" :height="size" :width="size" viewBox="0 -38 512 511" >
      <path
        d="m126.574219.5h-126.574219v60.960938h79.796875l80.632813 300.929687h309.03125l19.824218-19.828125v-41.132812h-282.078125zm347.710937 335.851562-11.039062 11.042969h-291.304688l-80.632812-300.933593h-76.308594v-30.960938h16.039062v18.632812h15v-18.632812h10.726563v18.632812h15v-18.632812h10.722656v18.632812h15v-18.632812h17.574219l80.636719 300.929688h278.585937zm0 0"
        :fill="fill1"/>
      <path
        d="m214.242188 412.8125c11.613281 0 21.058593-9.445312 21.058593-21.058594 0-11.609375-9.445312-21.054687-21.058593-21.054687-11.609376 0-21.058594 9.445312-21.058594 21.054687 0 11.613282 9.449218 21.058594 21.058594 21.058594zm0-27.113281c3.339843 0 6.058593 2.714843 6.058593 6.054687s-2.71875 6.058594-6.058593 6.058594c-3.339844 0-6.058594-2.71875-6.058594-6.058594s2.71875-6.054687 6.058594-6.054687zm0 0"
        :fill="fill1"/>
      <path
        d="m415.945312 412.8125c11.613282 0 21.058594-9.445312 21.058594-21.058594 0-11.609375-9.445312-21.054687-21.058594-21.054687-11.609374 0-21.054687 9.445312-21.054687 21.054687 0 11.613282 9.445313 21.058594 21.054687 21.058594zm0-27.113281c3.339844 0 6.058594 2.714843 6.058594 6.054687s-2.71875 6.058594-6.058594 6.058594c-3.339843 0-6.054687-2.71875-6.054687-6.058594s2.714844-6.054687 6.054687-6.054687zm0 0"
        :fill="fill2"/>
      <path d="m154.589844 51.898438h191.691406v15h-191.691406zm0 0" :fill="fill1"/>
      <path d="m481.503906 160.796875-14.488281-3.875-28.792969 107.605469h-226.652344v15h238.167969zm0 0"
            :fill="fill1"/>
      <path
        d="m240.363281 378.328125c2.152344 4.175781 3.242188 8.691406 3.242188 13.425781 0 16.191406-13.171875 29.363282-29.363281 29.363282-16.191407 0-29.363282-13.171876-29.363282-29.363282 0-4.734375 1.09375-9.25 3.242188-13.425781l-13.332032-6.871094c-3.210937 6.230469-4.910156 13.25-4.910156 20.296875 0 24.460938 19.902344 44.363282 44.363282 44.363282 24.460937 0 44.363281-19.902344 44.363281-44.363282 0-7.046875-1.695313-14.066406-4.90625-20.296875zm0 0"
        :fill="fill1"/>
      <path
        d="m442.066406 378.328125c2.152344 4.175781 3.242188 8.691406 3.242188 13.425781 0 16.191406-13.171875 29.363282-29.363282 29.363282-16.1875 0-29.359374-13.171876-29.359374-29.363282 0-4.734375 1.089843-9.25 3.238281-13.425781l-13.332031-6.871094c-3.210938 6.230469-4.90625 13.25-4.90625 20.296875 0 24.464844 19.898437 44.363282 44.359374 44.363282 24.464844 0 44.363282-19.898438 44.363282-44.363282 0-7.046875-1.695313-14.066406-4.90625-20.296875zm0 0"
        :fill="fill1"/>
      <path
        d="m434.417969 155.667969c42.777343 0 77.582031-34.804688 77.582031-77.582031 0-42.78125-34.804688-77.585938-77.582031-77.585938-42.78125 0-77.582031 34.804688-77.582031 77.585938 0 42.777343 34.800781 77.582031 77.582031 77.582031zm0-140.167969c34.507812 0 62.582031 28.074219 62.582031 62.582031 0 34.507813-28.074219 62.582031-62.582031 62.582031-34.507813 0-62.582031-28.074218-62.582031-62.582031 0-34.507812 28.070312-62.582031 62.582031-62.582031zm0 0"
        :fill="fill2"/>
      <path id="plus-anime"
        d="m413.332031 127.152344h42.167969v-27.984375h27.984375v-42.167969h-27.984375v-27.984375h-42.167969v27.984375h-27.980469v42.167969h27.980469zm-12.980469-42.984375v-12.167969h27.980469v-27.984375h12.167969v27.984375h27.984375v12.167969h-27.984375v27.980469h-12.167969v-27.980469zm0 0"
        :fill="fill2"/>
      <path
        d="m267.496094 102.226562h-97.417969l18.3125 68.351563h79.105469zm-15 53.351563h-52.597656l-10.273438-38.351563h62.871094zm0 0"
        :fill="fill1"/>
      <path d="m368.507812 146.609375v23.96875h36.042969v-15h-21.042969v-8.96875zm0 0" :fill="fill1"/>
      <path
        d="m267.496094 253.804688v-68.351563h-75.125l18.308594 68.351563zm-15-53.351563v38.351563h-30.304688l-10.273437-38.351563zm0 0"
        :fill="fill1"/>
      <path
        d="m281.515625 185.453125v68.351563h72.972656v-68.351563zm57.972656 53.351563h-42.972656v-38.351563h42.972656zm0 0"
        :fill="fill1"/>
      <path
        d="m368.507812 253.804688h56.335938l18.289062-68.351563h-74.625zm15-53.351563h40.082032l-10.261719 38.351563h-29.820313zm0 0"
        :fill="fill1"/>
      <path d="m281.515625 170.578125h72.972656v-68.351563h-72.972656zm15-53.351563h42.972656v38.351563h-42.972656zm0 0"
            :fill="fill1"/>
      <path d="m456.570312 339.222656h-104.976562v-15h104.976562zm-114.976562 0h-15v-15h15zm-25 0h-15v-15h15zm0 0"
            :fill="fill1"/>
    </svg>
</template>

<script>
  export default {
    name: 'add-to-basket',
    props:['fill1','fill2','size'],
    props: {
      fill1: {
        type: String,
        default: ''
      },
      fill2: {
        type: String,
        default: ''
      },
      size: {
        type: String,
        default: '45'
      },
    },
  }
</script>

<style lang="less" scoped>
#icon-add-to-basket{
  vertical-align: middle;
  cursor: pointer;
}
/*@keyframes spin { 100% { transform:rotateZ(360deg); } }*/
  /*#plus-anime{*/
    /*display: inline-block;*/
    /*animation:spin 4s linear infinite;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/icons/add-to-basket.vue